<template>
  <div id="admin-page" class="main-page">
    <p class="app-page-title">Dashboard</p>
    <div class="container">
      <div class="admin-section">
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <p class="merchant-app-section-title">Applications</p>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-right">
            <b-input-group size="sm" class="search-bar">
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Type to Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>

        <!-- Main table element -->
        <b-table
          v-if="isRenderDone"
          show-empty
          small
          stacked="md"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="1000000"
          :filter="filter"
          :filter-included-fields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :tbody-tr-class="rowClass"
          @filtered="onFiltered"
        >
          <template v-slot:cell(name)="row" class="Fart">{{ row.value.first }} {{ row.value.last }}</template>

          <template v-slot:cell(actions)="row">
              <router-link
                size="sm"
                tag="button"
                class="btn mr-1 btn-secondary btn-sm"
                style="color:white;"
                :to="{ name: 'admin-apss-detail',params:{key:row.item.uid,app:row.item.app_type} }"
              >View</router-link>
              <router-link
              size="sm"
              tag="button"
              class="btn mr-1 btn-secondary btn-sm"
                style="color:white;"
                :to="{ name: 'admin-apss-edit',params:{key:row.item.uid,app:row.item.app_type} }"
              >Edit</router-link>
            <b-button size="sm" class="mr-1" @click="info(row.item, row.index, $event.target)">Delete</b-button>
            <b-button size="sm" class="mr-1" @click="bank(row.item, row.index, $event.target)">Submit</b-button>
            <b-button size="sm" class="mr-1" @click="status(row.item, row.index, $event.target)">Status</b-button>
          </template>
        </b-table>
        <div v-else class="d-flex justify-content-center mt-4">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <!-- Info modal -->
        <b-modal :id="infoModal.id" :title="infoModal.title" @hide="resetInfoModal">
          <p>{{ infoModal.message }}</p>
          <p>
            <b>Full name:</b>
            {{ infoModal.user_full_name }}
          </p>
          <p>
            <b>Email:</b>
            {{ infoModal.user_email }}
          </p>
          <p>
            <b>Application:</b>
            {{ infoModal.user_app_type }}
          </p>
          <template v-slot:modal-footer="{ ok,cancel}">
            <b-button variant="secondary" @click="ok()">Cancel</b-button>
            <b-button
              variant="danger"
              @click="deleteapp(infoModal.index,cancel,infoModal.appcode)"
            >Delete</b-button>
          </template>
        </b-modal>

        <!-- Bank modal -->
        <b-modal :id="bankModal.id" ref="modal" @hide="resetModal" @hidden="resetModal" @ok="handleOk($event, bankModal)">
          <template #modal-header="{ close }">
            <div>
                <h5 class="modal-title">Submit application to broker</h5>
                <h6>Application: {{bankModal.user_full_name}}</h6>
            </div>
            <button type="button" aria-label="Close" class="close" @click="close()">×</button>
          </template>
          <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group
              style="margin-bottom:0px;"
              label-for="name-input"
              invalid-feedback="Must a valid Email"
              :state="nameState"
            >
              <b-form-input
                type="email"
                id="name-input"
                placeholder="Broker's email address"
                v-model="brokerEmail"
                :state="nameState"
                required
              ></b-form-input>
            </b-form-group>
          </form>
          <template v-slot:modal-footer="{ cancel }">
            <p v-if="brokerEmailWasSent" class="success-message"><i class="fas fa fa-check-circle icon"></i>Application sent</p>
            <p v-if="brokerEmailWasFailed" class="success-message" style="color:red"><i class="fas fa fa-times-circle icon"></i>Sending application failed</p>
            <div style="margin-left:auto">
              <b-button variant="secondary" @click="cancel()">Cancel</b-button>
              <b-button v-if="brokerEmailLoading" disabled class="form-button sending" type="submit" style="margin-left:5px"><i class="fa fa-spinner fa-pulse fa fa-fw icon"></i>Submitting</b-button>
              <b-button
                v-else
                type="submit"
                style="margin-left:5px"
                variant="success"
                @click="handleOk($event, bankModal)"
              >Submit</b-button>
            </div>
          </template>
        </b-modal>

        <!-- Status modal -->
        <b-modal :id="statusModal.id" :title="statusModal.title" @hide="resetStatusModal">
          <p>{{ statusModal.message }}</p>
          <template v-slot:modal-footer="{ ok,cancel}">
            <b-button variant="secondary" @click="ok()">Cancel</b-button>
            <b-button
              variant="danger"
              @click="rejectapp(cancel, statusModal.appcode)"
            >Reject</b-button>
            <b-button
              variant="success"
              @click="approveapp(cancel, statusModal.appcode)"
            >Approve</b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Admin",
  props: {
    msg: String
  },
  data() {
    return {
      brokerEmail: '',
      nameState: null,
      brokerEmailLoading: false,
      brokerEmailWasSent: false,
      brokerEmailWasFailed: false,
      fields: [
        {
          key: "fullname",
          label: "Full name",
          sortable: true,
          sortDirection: "desc"
        },
        { key: "app_user", label: "Email", sortable: true },
        { key: "completed_field", label: "Incomplete Fields", sortable: true },
        { key: "actions", label: "Actions" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      },
      bankModal: {
        id: "bank-modal",
        title: "",
        content: ""
      },
      statusModal: {
        id: "status-modal",
        title: "",
        content: ""
      },
      isRenderDone: false,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    items() {
      return this.$store.state.appList;
    },
    accessToken(){
      return this.$store.state.accessToken
    }
  },
  beforeCreate() {
  },
  async created() {
    await this.$store.dispatch("get_app_list")
    console.log(this.items.length, 'this.items.length')
    // change this to true indicate that starting data is ready.
    this.isRenderDone = true;
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
      this.$store.dispatch("verifyToken", this.accessToken);

  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.brokerEmail = ''
      this.brokerEmailWasSent = false
      this.brokerEmailWasFailed = false
      this.nameState = null
    },
    handleOk(bvModalEvt, bank) {
      this.brokerEmailWasSent=false;
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit(bank)
    },
    handleSubmit(bank) {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      this.brokerEmailLoading=true
      // do axios here
      var form = {
                appcode: bank.apptype,
                broker_email: this.brokerEmail,
                app_id: bank.appcode
            }
      this.$store
        .dispatch("sendBrokerEmail", form)
        .then(res => {
            // this.makeToast('success', 'Success!', 'Yor request was sent.')
            this.brokerEmailLoading=false;
            this.brokerEmailWasSent=true;
            setTimeout(this.hideMessage, 10000);
        })
        .catch(err => {
            // this.makeToast('danger', 'Error!', 'Failed to send your request.')
            this.brokerEmailLoading=false;
            this.brokerEmailWasFailed=true;
            setTimeout(this.hideMessage, 10000);
        });
    },
    hideMessage(){
        this.brokerEmailWasSent=false;
        this.brokerEmailWasFailed=false;
    },
    rowClass(item, type) {
      if (!item || type !== "row") return
      if (item.completed_field > 10) return "table-danger"
      if (item.completed_field < 11 && item.completed_field > 0) return "table-warning"
      if (item.completed_field == 0) return "table-success"
    },
    info(item, index, button) {
      this.infoModal.title = "Delete application";
      this.infoModal.message =
        "Are you sure you want to delete this application ?";
      this.infoModal.user_full_name = item.fullname;
      this.infoModal.user_email = item.app_user;
      this.infoModal.user_app_type = item.app_name;
      this.infoModal.index = index;
      this.infoModal.appcode = item.uid;

      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    bank(item, index, button) {
      this.bankModal.title = "Submit application to broker";
      this.bankModal.message =
        "Do you want to submit this application to the broker ?";
      this.bankModal.user_full_name = item.fullname;
      this.bankModal.user_email = item.app_user;
      this.bankModal.user_app_type = item.app_name;
      this.bankModal.index = index;
      this.bankModal.appcode = item.uid;
      this.bankModal.apptype = item.app_type;

      this.$root.$emit("bv::show::modal", this.bankModal.id, button);
    },
    status(item, index, button) {
      this.statusModal.title = "Status application";
      this.statusModal.message =
        "Do you want to reject or approve this application ?";
      this.statusModal.user_full_name = item.fullname;
      this.statusModal.user_email = item.app_user;
      this.statusModal.user_app_type = item.app_name;
      this.statusModal.index = index;
      this.statusModal.appcode = item.uid;

      this.$root.$emit("bv::show::modal", this.statusModal.id, button);
    },
    messages(item, index, button) {
      return this.$router.push({ name: "Message" });
    },
    deleteapp(index, cancel, appcode) {
      this.$store.dispatch("delete_app", appcode);
      this.$delete(this.items, index);
      cancel();
    },
    rejectapp(cancel, appcode) {
      var payload = {
        appcode : appcode,
        status:"Rejected"

      }
      this.$store.dispatch("status_app", payload);
      cancel();
    },
    approveapp(cancel, appcode) {
      var payload = {
        appcode : appcode,
        status:"Approved"

      }
      this.$store.dispatch("status_app", payload);
      cancel();
    },
    submitapp( cancel, appcode) {
      var payload = {
        appcode : appcode,
        submit:"Submited"

      }
      this.$store.dispatch("submit_app", payload);
      cancel();
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    resetBankModal() {
      this.bankModal.title = "";
      this.bankModal.content = "";
    },
    resetStatusModal() {
      this.statusModal.title = "";
      this.statusModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style>
.success-message {
    align-self: center;
    margin-bottom: 0px;
    font-weight: bold;
    color: #1976d2;
    transition: visibility 0s, opacity 0.5s linear;
}
.success-message .icon {
    padding-right: 5px;
}
#admin-page {
  margin-bottom: 100px;
}
.admin-section {
  margin-top: 35px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 50px;
}
.table {
  margin-bottom: 0;
}
.table td {
  vertical-align: middle !important;
}
.table-sm td,
.table-sm th {
  padding: 0.5rem !important;
}
@media (max-width: 767.98px) {
  #admin-page {
    margin-bottom: 50px;
  }
  .admin-section {
    padding: 25px;
  }
  .search-bar {
    margin-bottom: 15px;
  }
  #admin-page .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before {
    width: auto !important;
    white-space: pre !important;
    display: inline-block !important;
    padding-right: 100% !important;
  }
  #admin-page .table.b-table.b-table-stacked-md > tbody > tr > [data-label] > div {
    display: inline-table !important;
    width: 100% !important;
  }
  #admin-page .btn-group-sm>.btn, #admin-page  .btn-sm  {
    font-size: .65rem;
  }
}
</style>
